module.exports = require("react-image-magnify");


//////////////////
// WEBPACK FOOTER
// external "react-image-magnify"
// module id = 334
// module chunks = 0